// extracted by mini-css-extract-plugin
module.exports = {"table-head":"TableHead_table-head__3CWK_","table-head-row":"TableHead_table-head-row__2DIRw","table-head-cell":"TableHead_table-head-cell__jnOzz"};